import React from "react";
import HeaderOne from "../Components/Header/HeaderOne";
import { Helmet } from "react-helmet-async";
import ShopInner from "../Components/Policies/ShippingPolicy";
import FooterFour from "../Components/Footer/FooterOne";
import ScrollToTop from "../Components/ScrollToTop";

function Shop() {
  return (
    <>
      <Helmet>
        <title>Shipping Policy | Howly Wizard</title>
      </Helmet>
      <HeaderOne />
      <ShopInner />
      <FooterFour />
      <ScrollToTop />
    </>
  );
}

export default Shop;
